{
  "hiLinkTypes": {
    "raw": "Metrics indicator (metric)",
    "calculate": "Calculated (calc)",
    "event": "Event",
    "alert_hint": "Metrics indicator (ci_hint)",
    "event_hint": "Event",
    "static": "CI status"
  },
  "hiStatusValues": {
    "noData": "No data",
    "ok": "Ok",
    "warning": "Warning",
    "error": "Error",
    "criticalError": "Critical error",
    "service": "Service"
  }
}